import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingContext, M_CheckBox, M_SimpleTable, M_TabsInpage, BufferService, M_StateActions, MTimeLine, M_Button } from 'src/components/M_Components'
import { CalendarViewWeekOutlined, HomeOutlined, LocalShippingOutlined, FileCopyOutlined, InfoOutlined, WarningAmberOutlined, DescriptionOutlined, HistoryOutlined, KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material'
import CropSquareIcon from '@mui/icons-material/CropSquare'
import { useDispatch, useSelector } from 'react-redux'
import ECMRComponent from './componentsOrderService/ecmr'
import './orderServices.css'

export default function ViewOrderService() {
  const dispatch = useDispatch()
  const M_State = useSelector((state) => state.StateKeyValue)
  const { t } = useTranslation()
  const ctx = useContext(LoadingContext)
  const [orderId, setOrderId] = useState('')
  const [tabValue, setTabValue] = useState(1)
  const [isFirstLoop, setIsFirstLoop] = useState(true)
  const [id, setId] = useState(M_State.filter(obj => obj.key === 'selectedTab')[0]?.value)
  const [optionsOrderService, setOptionsOrderService] = useState([])
  const [optionsTransportResources, setOptionsTransportResources] = useState([])
  const [optionsSubResources, setOptionsSubResources] = useState([])
  const [optionsServiceContainer, setOptionsServiceContainer] = useState([])
  const [optionsRORO, setOptionsRORO] = useState([])
  const [optionsShippingInformation, setOptionsShippingInformation] = useState([])
  const [optionsADR, setOptionsADR] = useState([])
  const [optionsAddress, setOptionsAddress] = useState([])
  const [files, setFiles] = useState([])
  const [collapsedSections, setCollapsedSections] = useState({
    transport: false,
    address: false,
    tabs: false
  })

  // get
  const [orderService, setOrderService] = useState(new Map())
  const [transportResources, setTransportResources] = useState(new Map())
  const [address, setAddress] = useState([])
  const [container, setContainer] = useState(new Map())
  const [ROROMap, setROROMap] = useState(new Map())
  const [shippingInformation, setShippingInformation] = useState(new Map())
  const [ADRMap, setADRMap] = useState([])
  const [historyMovements, setHistoryMovements] = useState([])

  const bufferServiceOrderService = new BufferService('ServiceOrder')
  const bufferServiceTransportResource = new BufferService('TransportResource')
  const bufferServiceContainer = new BufferService('ServiceContainer')
  const bufferServiceRORO = new BufferService('RORO')
  const bufferServiceShippingInformation = new BufferService('ExpeditionInfo')
  const bufferServiceADR = new BufferService('ADRClassification')
  const bufferServiceAddress = new BufferService('ServiceOrderAddress')
  const bufferServiceHistoryMovements = new BufferService('ServiceOrderChangeState')
  const bufferServiceTransportSubResource = new BufferService('TransportSubResource')


  const sessionKeys = ['optionsOrderService', 'optionsTransportResources', 'optionsSubResources', 'optionsServiceContainer', 'optionsRORO', 'optionsAddress', 'optionsShippingInformation', 'optionsADR', 'orderService', 'transportResources', 'container', 'ROROMap', 'address', 'shippingInformation', 'ADRMap', 'orderId', 'files', 'historyMovements']

  useEffect(() => {
    if (isFirstLoop) {
      ctx.setIsLoad(true)
      getSessionStorageData(id)
      setIsFirstLoop(false)
    }
    // eslint-disable-next-line 
  }, [])

  // eslint-disable-next-line 
  useEffect(() => {
    const newId = M_State.filter(obj => obj.key === 'selectedTab')[0]?.value
    if (newId !== id) {
      setId(newId)
      getSessionStorageData(newId)
    }
  })

  useEffect(() => {
    const tempArray = []
    sessionKeys.forEach((key) => {
      tempArray.push(sessionStorageMachine(id, key, key))
    })
    dispatch(M_StateActions.addM_State({ key: id, value: tempArray }))
    // eslint-disable-next-line
  }, [id, optionsOrderService, optionsTransportResources, optionsSubResources, optionsServiceContainer, optionsRORO, optionsAddress, optionsShippingInformation, optionsADR, orderService, transportResources, container, ROROMap, address, shippingInformation, ADRMap, orderId, files, historyMovements])

  const sessionStorageMachine = (id, key, value) => {
    let tempObj = {}
    // eslint-disable-next-line
    if (eval(value) instanceof Map) {
      // eslint-disable-next-line
      tempObj = { key: `${key}`, value: (Array.from(eval(value))) }
    } else {
      // eslint-disable-next-line
      tempObj = { key: `${key}`, value: (eval(value)) }
    }
    return tempObj
  }

  const getSessionStorageData = (sessionID) => {
    ctx.setIsLoad(true)
    const M_StateData = M_State.filter(obj => obj.key === sessionID)[0]?.value
    if (M_StateData) {
      const tempOOS = M_StateData.filter(obj => obj.key === `optionsOrderService`)[0]?.value
      const tempOTR = M_StateData.filter(obj => obj.key === `optionsTransportResources`)[0]?.value
      const tempOSR = M_StateData.filter(obj => obj.key === `optionsSubResources`)[0]?.value
      const tempOSC = M_StateData.filter(obj => obj.key === `optionsServiceContainer`)[0]?.value
      const tempORO = M_StateData.filter(obj => obj.key === `optionsRORO`)[0]?.value
      const tempOAD = M_StateData.filter(obj => obj.key === `optionsAddress`)[0]?.value
      const tempOSI = M_StateData.filter(obj => obj.key === `optionsShippingInformation`)[0]?.value
      const tempOAR = M_StateData.filter(obj => obj.key === `optionsADR`)[0]?.value
      const tempOS = M_StateData.filter(obj => obj.key === `orderService`)[0]?.value
      const tempTR = M_StateData.filter(obj => obj.key === `transportResources`)[0]?.value
      const tempCO = M_StateData.filter(obj => obj.key === `container`)[0]?.value
      const tempRM = M_StateData.filter(obj => obj.key === `ROROMap`)[0]?.value
      const tempAD = M_StateData.filter(obj => obj.key === `address`)[0]?.value
      const tempSI = M_StateData.filter(obj => obj.key === `shippingInformation`)[0]?.value
      const tempAM = M_StateData.filter(obj => obj.key === `ADRMap`)[0]?.value
      const tempOI = M_StateData.filter(obj => obj.key === `orderId`)[0]?.value
      const tempFiles = M_StateData.filter(obj => obj.key === `files`)[0]?.value
      const tempHM = M_StateData.filter(obj => obj.key === `historyMovements`)[0]?.value
      if (tempOOS || tempOTR || tempOSR || tempOSC || tempORO || tempOAD || tempOSI || tempOAR || tempOS || tempTR || tempCO || tempRM || tempAD || tempAM || tempOI || tempFiles || tempHM) {
        setOptionsOrderService(tempOOS)
        setOptionsTransportResources(tempOTR)
        setOptionsSubResources(Array.isArray(tempOSR) ? tempOSR : [])
        setOptionsServiceContainer(tempOSC)
        setOptionsRORO(tempORO)
        setOptionsAddress(tempOAD)
        setOptionsShippingInformation(tempOSI)
        setOptionsADR(tempOAR)
        setOrderService(new Map(tempOS))
        setTransportResources(new Map(tempTR))
        setContainer(new Map(tempCO))
        setROROMap(new Map(tempRM))
        setAddress(tempAD)
        setShippingInformation(new Map(tempSI))
        setADRMap(tempAM)
        setOrderId(tempOI)
        setFiles(tempFiles)
        setHistoryMovements(tempHM)
        ctx.setIsLoad(false)
        return
      }
    }
    getOrderService()
  }

  const getOrderService = () => {
    const lines = ctx.passValue?.get('lines') || ""
    const getId = lines.Id || lines.ServiceOrderId
    ctx.passValue.delete('lines')
    ctx.setPassValue(new Map(ctx.passValue))
    setOrderId(getId)
    ctx.setIsLoad(true)

    bufferServiceOrderService.options().then((response) => {
      if (response.name === 'AxiosError') {
        ctx.toastMessages('error', response.response.data.Errors[0], '')
        return
      }
      setOptionsOrderService(response)
    })

    bufferServiceTransportResource.options().then((response) => {
      if (response.name === 'AxiosError') {
        ctx.toastMessages('error', response.response.data.Errors[0], '')
        return
      }
      setOptionsTransportResources(response)
    })

    bufferServiceTransportSubResource.get().then((response) => {
      if (response.name === 'AxiosError') {
        ctx.toastMessages('error', response.response.data.Errors[0], '')
        return
      }
      setOptionsSubResources(response.Items)
      console.log('optionsSubResources', response)
    })

    bufferServiceContainer.options().then((response) => {
      if (response.name === 'AxiosError') {
        ctx.toastMessages('error', response.response.data.Errors[0], '')
        return
      }
      setOptionsServiceContainer(response)
    })

    bufferServiceRORO.options().then((response) => {
      if (response.name === 'AxiosError') {
        ctx.toastMessages('error', response.response.data.Errors[0], '')
        return
      }
      setOptionsRORO(response)
    })

    bufferServiceShippingInformation.options().then((response) => {
      if (response.name === 'AxiosError') {
        ctx.toastMessages('error', response.response.data.Errors[0], '')
        return
      }
      setOptionsShippingInformation(response)
    })

    bufferServiceADR.options().then((response) => {
      if (response.name === 'AxiosError') {
        ctx.toastMessages('error', response.response.data.Errors[0], '')
        return
      }
      const filterOptionsADR = response.filter((elem) => elem.IsHiddenList !== true)
      const tempArray = filterOptionsADR.map((elem, index) => {
        return {
          id: index + 1,
          header: elem.NormalizedName,
          field: elem.Name
        }
      })
      setOptionsADR(tempArray)
    })

    bufferServiceAddress.options().then((response) => {
      if (response.name === 'AxiosError') {
        ctx.toastMessages('error', response.response.data.Errors[0], '')
        return
      }
      const filterOptionsAddress = response.filter((elem) => elem.IsHiddenList !== true)
      const tempArray = filterOptionsAddress.map((elem, index) => {
        return {
          id: index + 1,
          header: elem.NormalizedName,
          field: elem.Name
        }
      })
      setOptionsAddress(tempArray)
    })

    bufferServiceOrderService.getId(getId).then((response) => {
      if (response.name === 'AxiosError') {
        ctx.toastMessages('error', response.response.data.Errors[0], '')
        return
      }
      setOrderService(new Map(Object.entries(response)))
      setTransportResources(new Map(Object.entries(response.TransportResourceResponse)))
      if (response.RORO === true) {
        setROROMap(new Map(Object.entries(response.ROROInformation)))
      } else {
        setContainer(new Map(Object.entries(response.ServiceContainerResponse)))
      }
      setAddress(response.Address)
      setShippingInformation(new Map(Object.entries(response.ExpeditionInfoResponse)))
      if (response.TransportResourceResponse.ADR) {
        setADRMap(response.ADRInformation)
      }
      setFiles(response.DigitalArchives)

      console.log("response", response)

      bufferServiceHistoryMovements.filter(`?filter=serviceOrderId eq ${response.ServiceOrderId}`).then((respHistory) => {
        if (respHistory.name === 'AxiosError') {
          ctx.toastMessages('error', respHistory.response.data.Errors[0], '')
          return
        }
        setHistoryMovements(respHistory.Items)
        console.log('respHistory', respHistory.Items)
      })
    })
    ctx.setIsLoad(false)
  }

  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + '...'
    }
    return text
  }

  const timelineAddress = address.slice().sort((a, b) => a.Sequence - b.Sequence) // Cria uma cópia e ordena
    .map(value => ({
      marker: value.AddressType === "Pickup"
        ? <img src="/icons/svgsDaNet/arrowTop.svg" alt="arrowTop" />
        : value.AddressType === "Charge/Discharge"
          ? <img src="/icons/svgsDaNet/forkTimeline.svg" alt="forkTimeline" />
          : value.AddressType === "Delivery"
            ? <img src="/icons/svgsDaNet/arrowDown.svg" alt="arrowDown" />
            : <img src="/icons/svgsDaNet/pin.svg" alt="defaultArrow" />,
      header: truncateText(value.AddressName, 20), //nome da morada
      subHeader: (
        <>
          <span style={{ fontSize: '14px' }}>{value.AddressPlace} <br /></span>
          <span style={{ fontSize: '12px' }}>
            {value?.Distance != null ? value.Distance.toFixed(2) : "0"}Km - {value.Time != null ? (value.Time < 60 ? `${value.Time} Min` : `${(value.Time / 60).toFixed(2)} H`) : "0 Min"}
          </span>
        </>
      ),
      toolTipLabel: value.AddressName
    }))

  const timelineTracking = [
    { header: "Status", subHeader: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor" },
    { header: "Status", subHeader: "Lorem ipsum dolor sit amet, consectetur adipiscing elit" },
    { header: "Status", subHeader: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod" },
    { header: "Status", subHeader: "Lorem ipsum dolor sit amet, consectetur adipiscing elit" },
    { header: "Status", subHeader: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor" },
    { header: "Status", subHeader: "Lorem ipsum dolor sit amet, consectetur adipiscing elit" }
  ]

  const getIcon = (file) => {
    const fileName = file.Name ?? file.name
    const fileExtension = fileName?.toLowerCase() || ""

    switch (true) {
      case fileExtension.endsWith('.pdf'):
        return "/UploadFilesImages/pdf.png"
      case fileExtension.endsWith('.txt'):
        return "/UploadFilesImages/txt.png"
      case fileExtension.endsWith('.xlsx'):
      case fileExtension.endsWith('.csv'):
        return "/UploadFilesImages/excel.png"
      case fileExtension.endsWith('.pptx'):
        return "/UploadFilesImages/powerpoint.png"
      case fileExtension.endsWith('.docx'):
      case fileExtension.endsWith('.odt'):
        return "/UploadFilesImages/office.png"
      case fileExtension.endsWith('.rar'):
      case fileExtension.endsWith('.7z'):
      case fileExtension.endsWith('.zip'):
        return "/UploadFilesImages/zip.png"
      case fileExtension.endsWith('.eml'):
        return "/UploadFilesImages/email.png"
      default:
        return "/UploadFilesImages/images.png" // fallback
    }
  }

  const handleDownload = (base64Data, fileName) => {
    const link = document.createElement("a")
    link.href = base64Data
    link.download = fileName
    link.click()
  }

  const toggleSection = (sectionKey) => {
    setCollapsedSections((prev) => ({
      ...prev,
      [sectionKey]: !prev[sectionKey]
    }))
  }

  const normalizeTransportSubResourceName = (value) => {
    if (!value) return ''
    return String(value)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '')
  }

  const getTransportResourceCheckboxValue = (option) => {
    const mappedValue = transportResources.get(option.Name)

    if (typeof mappedValue === 'boolean') {
      return mappedValue
    }

    const transportSubResources = transportResources.get('TransportSubResources')

    if (!Array.isArray(transportSubResources) || transportSubResources.length === 0) {
      return false
    }

    const subResourcesLookup = new Set(
      transportSubResources
        .map((sr) => normalizeTransportSubResourceName(sr?.TransportSubResource))
        .filter(Boolean)
    )

    const optionKeys = [option.Name, option.NormalizedName]
      .map((name) => normalizeTransportSubResourceName(name))
      .filter(Boolean)

    if (optionKeys.length === 0) {
      return false
    }

    return optionKeys.some((key) => subResourcesLookup.has(key))
  }

  const Body1 = () => {
    return (
      <div className='divGlobalInformationContainer'>
        <div className='divAlignInputsInformationContainerOrderService'>
          {optionsServiceContainer.filter((elem) => elem.IsHiddenList !== true).map((elem, key) => (
            <div key={key}>
              {elem.Type !== 'boolean' ? (
                <div className='fontSizeLabelsOrderService'>
                  <b>{elem.NormalizedName}: </b>
                  {container.get(elem.Name) ? container.get(elem.Name) : '---'}
                </div>
              ) :
                <div className='divCheckboxOrderService'>
                  <div className='fontSizeLabelsOrderService'>
                    <b>{elem.NormalizedName}: </b>
                  </div>
                  <div>
                    <M_CheckBox
                      checked={container.get(elem.Name) || false}
                      disabled={true}
                    />
                  </div>
                </div>
              }

            </div>
          ))}
        </div>
        <div className='divImageContainerOrderService'>
          <img src="/images/container1.png"
            alt="Container1" className='imageContainerOrderService'
          />
          <i className='divPositionWidth'>
            <b>{container.get('Height') ? container.get('Height') : '---'}</b> M
          </i>
          <i className='divPositionHeight'>
            <b>{container.get('Width') ? container.get('Width') : '---'}</b> M
          </i>
          <i className='divPositionLenght'>
            <b>{container.get('Length') ? container.get('Length') : '---'}</b> M
          </i>
        </div>
      </div>
    )
  }

  const Body2 = () => {
    return (
      <div className='divAlignLinesObservations'>
        {optionsRORO?.filter((elem) => elem.IsHiddenList !== true)?.map((elem2, key) => (
          <div key={key}>
            {elem2.Type !== 'boolean' ? (
              <div className='fontSizeLabelsOrderService divInputObservations'>
                <b>{elem2.NormalizedName}: </b>
                {ROROMap.get(elem2.Name) ? ROROMap.get(elem2.Name) : '---'}
                <b>{elem2.Name === 'NetWeight' || elem2.Name === 'LoadWeight' ? ' Kg' : ''}</b>
              </div>
            ) :
              <div className='divCheckboxOrderService'>
                <div className='fontSizeLabelsOrderService'>
                  <b>{elem2.NormalizedName}: </b>
                </div>
                <div>
                  <M_CheckBox
                    checked={ROROMap.get(elem2.Name) || false}
                    disabled={true}
                  />
                </div>
              </div>
            }

          </div>
        ))}
      </div>
    )
  }

  const Body3 = () => {
    const adrRowsWithFallback = (ADRMap || []).map((row) =>
      Object.fromEntries(
        Object.entries(row).map(([key, value]) => [key, value == null ? '---' : value])
      )
    )

    return (
      <div style={{ padding: '16px' }}>
        <M_SimpleTable
          columns={optionsADR}
          rows={adrRowsWithFallback}
        />
      </div>
    )
  }

  const Body4 = () => {
    return (
      <div style={{ padding: '16px' }}>
        <M_SimpleTable
          columns={optionsAddress}
          rows={address}
        />
      </div>
    )
  }

  const Body5 = () => {
    return (
      <div className='divAlignCardsOtherInformationsOrderService'>
        <div>
          <div>
            <h3>{t("Entities")}</h3>
          </div>
          <div className='divCardObservations'>
            {optionsOrderService?.filter((elem) => elem.IsHiddenList !== true && elem.GroupByInfo === "Recetor" && elem.Type === 'string')?.map((elem2, key) => (
              <div key={key}>
                <div className='fontSizeLabelsOrderService divInputObservations'>
                  <b>{elem2.NormalizedName}: </b>
                  {orderService.get(elem2.Name) ? orderService.get(elem2.Name) : '---'}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div>
          <div>
            <h3>{t("ShippingInformation")}</h3>
          </div>
          <div className='divCardObservations'>
            {optionsShippingInformation?.filter((elem) => elem.IsHiddenList !== true)?.map((elem2, key) => (
              <div key={key}>
                {elem2.Type !== 'boolean' ?

                  <div className='fontSizeLabelsOrderService divInputObservations'>
                    <b>{elem2.NormalizedName}: </b>
                    {shippingInformation.get(elem2.Name) ? shippingInformation.get(elem2.Name) : '---'}
                  </div>
                  :
                  <div className='divCheckboxOrderService'>
                    <div className='fontSizeLabelsOrderService'>
                      <b>{elem2.NormalizedName}: </b>
                    </div>
                    <div>
                      <M_CheckBox
                        checked={shippingInformation.get(elem2.Name) || false}
                        disabled={true}
                      />
                    </div>
                  </div>
                }
              </div>
            ))}
          </div>
        </div>
        <div>
          <div>
            <h3>{t("Observations")}</h3>
          </div>
          <div className='divCardObservations'>
            {optionsOrderService?.filter((elem) => elem.IsHiddenList !== true && elem.GroupByInfo === "Notes")?.map((elem2, key) => (
              <div key={key}>
                <div className='fontSizeLabelsOrderService divInputObservations'>
                  <b>{elem2.NormalizedName}: </b>
                  {orderService.get(elem2.Name) ? orderService.get(elem2.Name) : '---'}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }

  const Body6 = () => {
    return (
      <div>
        {files.length > 0 ? (
          <div className="divAlignFiles">
            {files.map((file, key) => (
              <div key={key} className="divAlignEachFile">
                <img
                  src={getIcon(file)}
                  alt="ícone do ficheiro"
                  style={{ width: 40, height: 40, marginRight: 8 }}
                />
                <div>
                  <div className="fontSizeLabelsOrderService divInputObservations">
                    <b>{file.Name}</b>
                  </div>
                  <div style={{ fontSize: "13px", color: "var(--color-grey-dark)" }}>
                    {t("Category")}: {file.DigitalArchiveCategory}
                    <span style={{ marginLeft: 20 }}>{file.InsertionDate}</span>
                  </div>
                </div>
                <div style={{ marginLeft: "30px" }}>
                  <M_Button
                    icon={
                      <img
                        src="/icons/svgsDaNet/download.svg"
                        alt="download"
                        style={{ width: "25px" }}
                      />
                    }
                    tooltip={t("Download")}
                    onClick={() => handleDownload(file.ImageBase64, file.Name)}

                  />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div style={{ width: "100%", alignItems: "center", justifyContent: "center", display: "flex", flexDirection: "column", marginTop: "20px" }}>
            <div>
              <img src="/images/noFiles.png" alt="No Files" style={{ width: "70px" }} />
            </div>
            {t("NoFilesToShow")}
          </div>
        )}
      </div>
    )
  }

  const Body7 = () => (
    <ECMRComponent orderId={id} orderService={orderService} isActive={tabValue === 6} />
  )

  const Body8 = () => {
    return (
      <div style={{ padding: '16px' }}>
        <div style={{ width: '100%' }} className='divHistoryMovementsWrapperOrderService'>
          <div className='tableHistoryMovementsOrderService'>
            <div style={{ textAlign: 'center' }}>{t("Status")}</div>
            <div style={{ textAlign: 'center' }}>{t("DateChange")}</div>
            <div style={{ textAlign: 'center' }}>{t("Trinomial")}</div>
            <div style={{ textAlign: 'center' }}>{t("Notes")} </div>
            <div style={{ textAlign: 'center' }}>{t("CreatedBy")} </div>
          </div>
          <div>
            {historyMovements?.map((elem, key) => (
              <div key={key} className='divRowHistoryMovementsOrderService'>
                <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
                  <div style={{ backgroundColor: elem.ServiceOrderWorkflowFromStateColor || "#000000" }} className='divIndicatorStatusHistoryMovementsOrderService'>
                    {elem.ServiceOrderWorkflowFromState}
                  </div>
                  <span>→</span>
                  <div style={{ backgroundColor: elem.ServiceOrderWorkflowToStateColor || "#000000" }} className='divIndicatorStatusHistoryMovementsOrderService'>
                    {elem.ServiceOrderWorkflowToState}
                  </div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  {new Date(elem.MovDate).toLocaleString('pt-PT', { day: '2-digit', month: '2-digit', year: 'numeric' })}
                </div>
                <div style={{ textAlign: 'center' }}>{elem.TransportName ? `${elem.TrailerName} + ${elem.DriverName} + ${elem.TransportName}` : t("NoData")}</div>
                <div style={{ textAlign: 'center' }}>{elem.Notes || t("NoData")}</div>
                <div style={{ textAlign: 'center' }}>{elem.CreatedBy || t("NoData")}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }


  const itemsMenuTab = [
    ...(orderService.get('RORO') === true
      ? [{ id: 1, labelTab: 'RORO', iconTab: <CropSquareIcon />, renderBody: <Body2 /> }]
      : [{ id: 1, labelTab: t("Container"), iconTab: <CalendarViewWeekOutlined />, renderBody: <Body1 /> }]
    ),
    ...(transportResources.get('ADR') === true
      ? [{ id: 2, labelTab: 'ADR ', iconTab: <WarningAmberOutlined />, renderBody: <Body3 /> }]
      : []
    ),
    { id: 3, labelTab: t("Addresses"), iconTab: <HomeOutlined />, renderBody: <Body4 /> },
    { id: 7, labelTab: t("HistoryMovements"), iconTab: <HistoryOutlined />, renderBody: <Body8 /> },
    { id: 4, labelTab: t("OtherInformations"), iconTab: <InfoOutlined />, renderBody: <Body5 /> },
    { id: 5, labelTab: t("DigitalArchive"), iconTab: <FileCopyOutlined />, renderBody: <Body6 /> },
    { id: 6, labelTab: "eCMR", iconTab: <DescriptionOutlined />, renderBody: <Body7 /> },
  ]

  return (
    <div className='backgroundForms viewOrderServicePage'>
      <div>
        <div className='divGlobalIDStatus'>
          <div className='divIDOrderService'>
            {t("NumberOrder")} #{orderService.get('ServiceOrderId')}
          </div>
          <div className='divGlobalStatusOrderService'>
            <div className='divLabelStatus'>
              <b>{t("Status")}:</b>
              <div className='divBodyStatus' style={{ backgroundColor: orderService.get('StateColor') || "#000000" }}>
                {orderService.get('ServiceOrderState') || "Inválido"}
              </div>
            </div>
          </div>
        </div>
        <br />
        <div className='viewCard viewGeneralInfoCard'>
          <div className='divAlignInputsViewOrderService'>
            {optionsOrderService?.filter((elem) => elem.IsHiddenList !== true && elem.GroupByInfo === "")?.map((elem2, key) => (
              <div key={key} className='viewInfoItem'>
                {elem2.Type === "datetime" ? (
                  <div className="fontSizeLabelsOrderService">
                    <b>{elem2.NormalizedName}: </b>
                    {orderService.get(elem2.Name)
                      ? `${new Date(orderService.get(elem2.Name)).toLocaleDateString("pt-PT")} ${new Date(orderService.get(elem2.Name)).toLocaleTimeString("pt-PT", {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}`
                      : ""}
                  </div>
                ) : elem2.Type === "boolean" ? (
                  <div className="divCheckboxOrderService">
                    <div className="fontSizeLabelsOrderService">
                      <b >{elem2.NormalizedName}: </b>
                    </div>
                    <div>
                      <M_CheckBox
                        checked={orderService.get(elem2.Name) || false}
                        disabled={true}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="fontSizeLabelsOrderService">
                    <b>{elem2.NormalizedName}: </b>
                    {
                      elem2.Name === 'Distance'
                        ? Number(orderService.get(elem2.Name)).toFixed(2)
                        : orderService.get(elem2.Name)
                    }
                    {elem2.Name === 'Distance' ? ' Km' : ''}
                    {elem2.Name === 'Time' ? ' H' : ''}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className='divGlobalResourcesAddressesOrderService'>
          <div className='divBlockResourcesOrderService viewTransportCard'>
            <div className='divTitleCard'>
              <div className='viewCardTitleLeft divSizeTitle'>
                <div className='iconTitleCard'>
                  <LocalShippingOutlined className='viewTransportTitleIcon' />
                </div>
                <div className='labelTitleCard'>
                  {t("TransportResources")}
                </div>
              </div>
              <button
                type='button'
                className='viewAccordionButton'
                onClick={() => toggleSection('transport')}
                aria-label={collapsedSections.transport ? 'Expandir recursos de transporte' : 'Recolher recursos de transporte'}
              >
                {collapsedSections.transport ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
              </button>
            </div>
            {!collapsedSections.transport && <div className='divAlignResourcesViewOrderService'>
              <div className='resourceForeignGrid'>
                {optionsTransportResources
                  .filter((elem) => elem.IsHiddenList !== true && elem.IsForeignKey)
                  .map((elem1, key1) => (
                    <div key={`fk-${key1}`} className='resourceFieldOrderService'>
                      <span className='resourceFieldLabel'>{elem1.NormalizedName}</span>
                      <div className='resourceFieldValueBox'>
                        {transportResources.get(elem1.Name) || "---"}
                      </div>
                    </div>
                  ))}
              </div>

              <div className='resourceChecklistGrid'>
                {optionsTransportResources
                  .filter((elem) => elem.IsHiddenList !== true && !elem.IsForeignKey)
                  .map((elem1, key1) => (
                    <div key={`bool-${key1}`} className='resourceCheckboxRow'>
                      <div className='resourceCheckboxLabel'>{elem1.NormalizedName}:</div>
                      <M_CheckBox
                        checked={getTransportResourceCheckboxValue(elem1)}
                        disabled={true}
                      />
                    </div>
                  ))}

                {(Array.isArray(optionsSubResources) ? optionsSubResources : [])
                  .filter((elem) => elem?.IsHiddenList !== true)
                  .map((elem, idx) => (
                    <div key={`subresource-${elem?.Id ?? elem?.Name ?? idx}`} className='resourceCheckboxRow'>
                      <div className='resourceCheckboxLabel'>{elem.NormalizedName || elem.Name}:</div>
                      <M_CheckBox
                        checked={getTransportResourceCheckboxValue(elem)}
                        disabled={true}
                      />
                    </div>
                  ))}
              </div>
            </div>}
          </div>

          <div className='viewCard viewAddressCard'>
            <div className='divTitleCard'>
              <div className='viewCardTitleLeft divSizeTitle'>
                <div className='iconTitleCard'>
                  <HomeOutlined className='viewTransportTitleIcon' />
                </div>
                <div className='labelTitleCard'>
                  {t("Address")}
                </div>
              </div>
              <button
                type='button'
                className='viewAccordionButton'
                onClick={() => toggleSection('address')}
                aria-label={collapsedSections.address ? 'Expandir morada' : 'Recolher morada'}
              >
                {collapsedSections.address ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
              </button>
            </div>
            {!collapsedSections.address && <div className='viewAddressCardBody'>
              <div className='divGlobalTimeline'>
                <MTimeLine valueTimeline={timelineAddress} timeLineRowPosition='bottom' />
              </div>
              <div className='addressTimelineFootNote'>
                <InfoOutlined />
                <span>{t("RoutePreviewFromServiceOrder")} </span>
              </div>
            </div>}
          </div>
        </div>

        {/* divider */}
        {/* <div className='dividerBlocksOrderService'>
          <div className='divLineDividerOrderService'></div>
        </div>

        <div className='divGlobalInformationTracking'>
          <div className='divBlockResourcesOrderService'>
            <div className='divTitleCard'>
              <div className='divSizeTitle'>
                <div className='iconTitleCard'>
                  <img src="/icons/svgsDaNet/map-2.svg"
                    style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                    alt="Tracking"
                  />
                </div>
                <div className='labelTitleCard'>
                  {t("ShipmentTracking")}
                </div>
              </div>
            </div>
          </div>
          <div className='divGlobalTrackingOrderService'>
            <div className='divGlobalTimelineTrackingOrderService'>
              <MTimeLine
                valueTimeline={timelineTracking}
                forceVertical
              />

            </div>
            <div className='divGlobalMapTrackingOrderService'>
              Mapa
            </div>
          </div>
        </div> */}

        <div className='viewCard viewAddresscard' style={{ marginTop: '20px', padding: '16px' }}>
          <div className='divTitleCard'>
            <div className='viewCardTitleLeft divSizeTitle'>
              <div className='iconTitleCard'>
                <InfoOutlined className='viewTransportTitleIcon' />
              </div>
              <div className='labelTitleCard'>
                {t("InformationLabel")}
              </div>
            </div>
            <button
              type='button'
              className='viewAccordionButton'
              onClick={() => toggleSection('tabs')}
              aria-label={collapsedSections.tabs ? 'Expandir morada' : 'Recolher morada'}
            >
              {collapsedSections.tabs ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
            </button>
          </div>
          {!collapsedSections.tabs && (
            <M_TabsInpage
              type={"tabs"}
              renderTabs={itemsMenuTab}
              firstTabOpen={tabValue}
              onGetTab={(label, obj) => setTabValue(obj.id)}
              hoverSelectedColor={'var(--color-black)'}
            />
          )}
        </div>
      </div>
    </div>
  )
}

